import React, { useState } from "react";
import { useParams } from "react-router";
import "./Destination.css"
import vehiclesData from "../../FakeData/data.json"
import DestinationInfo from "../DestinationInfo/DestinationInfo";

const Destination = () => {
    const [toggleForm, setToggleForm] = useState(true); 
    const [pickFrom, setPickFrom] = useState("Gabtoli");
    const [pickTo, setPickTo] = useState("Gulshan");
    const {id} = useParams();
    const currentVehicle = vehiclesData.find(vehicle => vehicle.id === +id);
    const {seat} = currentVehicle;
    console.log(currentVehicle);
    const handleSearch = () =>{
        setToggleForm(false);
    }
  return (
    <section>
      <div className="container d-flex justify-content-between">
        <div className="row mt-5 ">
          <div className="col-md-4">
            {
                toggleForm && <form className="destination-form">
                <div className="mb-3">
                    <label for="exampleInputEmail1" className="form-label">Pick From</label>
                    <input onChange={(e)=> setPickFrom(e.target.value)} type="text" className="form-control" placeholder="Gabtoli" id="exampleInputEmail1" aria-describedby="emailHelp"/>
                </div>
                <div className="mb-3">
                    <label for="exampleInputPassword1" className="form-label">Pick To</label>
                    <input onChange={(e)=> setPickTo(e.target.value)} type="text" className="form-control" placeholder="Gulshan" id="exampleInputPassword1"/>
                </div>
                <div className="mb-3">
                    <label for="exampleInputPassword1" className="form-label">Date</label>
                    <input type="Date" className="form-control" id="exampleInputPassword1"/>
                </div>
                <input onClick={handleSearch} className="btn btn-primary" type="submit" value="Search" />
            </form>
            }
            {
                !toggleForm && <div>
                    <div className="location-wrapper">
                        <h2 className="location-from">From: {pickFrom}</h2>
                        <h2 className="location-to">To: {pickTo}</h2>
                        {
                            seat.map((seat, id) => <DestinationInfo key={id} vehicle={currentVehicle} seat={seat}/>)
                        }
                        <div onClick={() => setToggleForm(true)} className="btn btn-primary">Back To Search</div>
                    </div>
                </div>
            }
          </div>
          <div className="col-md-8">
            <iframe
              title="Destination Map"
              className="destination-map"
              src="https://www.google.com/maps/embed?pb=!1m28!1m12!1m3!1d58420.760382450506!2d90.34300648490505!3d23.77241735195392!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m13!3e6!4m5!1s0x3755c08c7261ffb3%3A0x11a1f0e97b9b5a14!2sGabtoli%20Bus%20Stand%2C%20Dhaka!3m2!1d23.7828652!2d90.3428929!4m5!1s0x3755c79ebfc24eab%3A0xea7dab563f12457a!2sGulshan%201%2C%20Dhaka!3m2!1d23.782062399999997!2d90.4160527!5e0!3m2!1sen!2sbd!4v1617723949373!5m2!1sen!2sbd"
              width="650"
              height="400"
              allowFullScreen=""
            ></iframe>
          </div>
        </div> 
      </div>
    </section>
  );
};

export default Destination;
